module.exports = __webpack_public_path__ + "static/media/card-size.1b3da3b2.svg";